@let detailsValue = details();
@let buildingValue = building();
@let labelGroupValue = labelGroup();
@let measuresOutOfScopeValue = measuresOutOfScope();
@if (hasPlannedMeasuresWithoutYear() && buildingValue) {
  <cfp-building-notification
    [buildingId]="buildingValue.id"
    [type]="BuildingNotificationTypeDTO.ROADMAPIMPLEMENTATIONYEAR"
  />
}
<cfp-roadmap-table
  [buildingId]="buildingId()!"
  [(rows)]="measures"
  [hasAIPredictedData]="hasPredictedData()"
  [years]="years()"
  [totals]="totals()"
  (rowClick)="onMeasureClick($event)"
  [showCellButton]="true"
  (cellClick)="onCellClick($event)"
  (toggleCompletedMeasures)="toggleCompletedMeasures($event)"
  [hasMeasureStatusesFilter]="hasAllMeasureStatuses()"
  [saving]="saving()"
  [loading]="loading() && !errorMessage()"
  [(predicting)]="predicting"
  [showAiPredictingButton]="!hasPredictedData()"
  [errorMessage]="errorMessage()"
  [defaultSortDescending]="true"
  [currencyCode]="detailsValue?.currencyCode"
  [showAddRow]="(measuresOutOfScopeValue?.length ?? 0) > 0"
  (measureStatusUpdate)="onMeasureStatusUpdate($event)"
  [labelGroup]="labelGroupValue"
  [showLabelGroup]="true"
  [showImplementedMeasuresToggle]="showImplementedMeasuresToggle()"
  [showEnergyLabelInRow]="showEnergyLabelInRow()"
  [showM2Toggle]="true"
  [showM2]="showM2()"
  [resetSort]="resetSort()"
  [canChangeUserDefinedEnergyLabel]="canChangeUserDefinedEnergyLabel()"
  [canResetUserDefinedEnergyLabel]="canResetUserDefinedEnergyLabel()"
  [(inChangeEnergyLabelMode)]="inChangeEnergyLabelMode"
  (energyLabelEdit)="editEnergyLabels()"
  (energyLabelSave)="saveEnergyLabels()"
  (energyLabelCancel)="cancelEnergyLabels()"
  (energyLabelReset)="resetEnergyLabels()"
  (showM2Change)="setShowM2($event)"
  (predict)="predictWithAI($event)"
  (energyLabelChange)="updateManualEnergyLabel($event.year, $event.label)"
>
  @let energyLabelsItem = labelGroupValue ? detailsValue?.energyLabels[labelGroupValue] : undefined;
  @let showImprovedLabelValue = showImprovedLabel();
  @let showImprovedLabelPlaceholderValue = showImprovedLabelPlaceholder();
  @if (
    detailsValue &&
    labelGroupValue &&
    energyLabelsItem?.currentEnergyLabel &&
    showDefaultTitle() &&
    ((showImprovedLabelValue && energyLabelsItem?.improvedEnergyLabel) || showImprovedLabelPlaceholderValue)
  ) {
    <div class="d-inline-block text-nowrap" title-content>
      {{ 'roadmap.from' | translate }}
      <cfp-energy-label
        class="d-inline-block align-middle"
        [energyLabel]="energyLabelsItem?.currentEnergyLabel"
        [size]="'xs'"
      />
      {{ 'roadmap.to' | translate }}
      @if (showImprovedLabelValue) {
        <cfp-energy-label
          class="d-inline-block align-middle"
          [energyLabel]="energyLabelsItem?.improvedEnergyLabel"
          [size]="'xs'"
        />
      } @else if (showImprovedLabelPlaceholderValue) {
        <cfp-energy-label
          class="d-inline-block align-middle"
          [energyLabel]="{ label: 'placeholder' }"
          [size]="'xs'"
          data-test="energyLabelImprovedPlaceholder"
        />
      }
    </div>
  }

  <ng-container intro-content>
    @if (intro(); as intro) {
      <p class="mb-4" [innerHtml]="intro | translate"></p>
    }
    @if (showMeasureRelationAlert) {
      <cfp-roadmap-measure-relation-alert />
    }
  </ng-container>

  @if (measuresOutOfScopeValue && measuresOutOfScopeValue.length > 0) {
    <ng-container add-row-content>
      <cfp-combobox
        (optionSelected)="addMeasure($event)"
        [options]="measuresOutOfScopeValue"
        [labelField]="'name'"
        [placeholder]="'roadmap.addMeasure' | translate"
        [noResultText]="'roadmap.measuresNotFound'"
        [loadingText]="'roadmap.loading'"
        [name]="'roadmapMeasures'"
        [container]="'body'"
        [disabled]="saving()"
        [footerTemplate]="showAddMeasure() ? footerTemplate : undefined"
        class="w-100"
      />

      <ng-template #footerTemplate>
        <button type="button" class="btn btn-light m-auto" (click)="addNewMeasure()">
          <i class="fa fa-plus me-2" aria-hidden="true"></i>{{ 'measure.add' | translate }}...
        </button>
      </ng-template>
    </ng-container>
  }
  @if (hasUserDefinedMeasures() && environment.icons.iconUserDefinedMeasure) {
    <div class="mt-4" bottom-content>
      <i [ngClass]="environment.icons.iconUserDefinedMeasure" aria-hidden="true"></i>
      <span class="ms-2">{{ 'measure.userDefined' | translate }}</span>
    </div>
  }
</cfp-roadmap-table>
@let buildingIdValue = buildingId();
@if (showCharts() && !loading() && hasPlannedMeasures() && !loadingYears() && buildingIdValue && buildingValue) {
  @defer (when hasCrremLicense()) {
    <div class="mt-5">
      <cfp-crrem-building-paris-pathway [buildingId]="buildingIdValue" [reloadTrigger]="detailsValue" />
    </div>
  }
  <div class="mt-5">
    <div class="row card-row">
      <div class="col-12 col-lg-6">
        <cfp-roadmap-chart
          [title]="'investmentAndCostReduction'"
          [propertyNames]="['investment', 'costReduction']"
          [details]="detailsValue"
          (showDataEvent)="onShowData($event)"
          [currencyCode]="detailsValue?.currencyCode"
        />
      </div>
      <div class="col-12 col-lg-6 card-col mt-5 mt-lg-0">
        <cfp-roadmap-chart
          [propertyNames]="['co2Consumption']"
          [startYear]="startEnergyConsumptionYear()"
          [details]="detailsValue"
          (showDataEvent)="onShowData($event)"
        />
      </div>
    </div>
    <div class="row card-row mt-5">
      <div class="col-12 col-lg-6">
        <cfp-roadmap-chart-usage
          [details]="detailsValue"
          #chartUsage
          (showDataEvent)="onShowData($event)"
          [building]="buildingValue"
        />
      </div>
      <div class="col-12 col-lg-6 card-col mt-5 mt-lg-0">
        @if (labelGroupValue === LabelGroupDTO.WEII) {
          @defer {
            <cfp-weii-roadmap-chart
              [buildingId]="buildingIdValue"
              [details]="detailsValue"
              (showDataEvent)="onShowData($event)"
            />
          }
        } @else {
          <cfp-roadmap-chart
            [propertyNames]="['co2ConsumptionReduction']"
            [details]="detailsValue"
            (showDataEvent)="onShowData($event)"
          />
        }
      </div>
    </div>
  </div>
}
